module.exports = __webpack_public_path__ + "media/images/common/revision_btn_l_ov-7f80c217ee56386ddffc4cd0bb4d2a2f.png";